import React from "react";
import { formatCurrency, formatDateTime } from "@/common/utils/formatters";
import { EstablishmentUserEventData } from "../types/events.type";
import FeeDetails from "@/features/billingEvents/components/FeesDetails";
import ConsumptionDetails from "@/features/billingEvents/components/ConsumptionDetails";
import RefundDetails from "@/features/billingEvents/components/RefundDetails";

export class EstablishmentUserEventTransformer {
  static tableTransformer() {
    return (events: EstablishmentUserEventData[]) => {
      return events.map((event) => ({
        protocol_number: event.protocol_number,
        eventable_type: eventableTypeTranslations[event.eventable_type] || 'Nao implementado',
        details: eventableDetailsComponent[event.eventable_type] ? React.createElement(eventableDetailsComponent[event.eventable_type], { data: event.eventable }) : '',
        total_amount: event.total_amount ? formatCurrency(event.total_amount) : '',
        fee_total_amount: <FeeDetails {...event} />,
        income_tax_total: event.income_tax_total ? formatCurrency(parseFloat(event.income_tax_total)) : '',
        client_branch: event.eventable?.client_branch?.display_name|| '',
        card: event.eventable?.card?.last_four_digits.padStart(8, '*') || '',
        author: event?.author?.full_name || '',
        created_at: formatDateTime(new Date(event?.created_at || 0))
      }));
    };
  }
}

const eventableDetailsComponent: { [key: string]: React.ComponentType<any>; } = {
  'Client::Consumption': ConsumptionDetails,
  'Billing::Refund': RefundDetails,
};

const eventableTypeTranslations: { [key: string]: string; } = {
  'Client::Consumption': 'Consumo',
  'Billing::Refund': 'Estorno',
};
